module.exports = __webpack_public_path__ + "static/media/resume.9d3da0e2.pdf";